import { round } from 'lodash-es'
import pluralize from 'pluralize'
import type { ElementType } from 'react'
import { AggregationData } from 'types'
import { getDisplayDurationFromSeconds } from 'utils'
import { Circle, Flex, Text } from '.'

interface Props {
  expanded?: boolean
  aggregations: {
    data?: AggregationData
    otherProps?: {
      Icon?: ElementType<{ color?: string; fontSize?: string }> | null
      label: string
      formatData: (data: AggregationData) => number
    }
  }[]
  excludeLabels?: string[]
}

export default function AnalyticsBar({ expanded, aggregations, excludeLabels }: Props) {
  return (
    <Flex
      justifyContent={{ base: 'space-between', lg: 'flex-start' }}
      columnGap={{ base: 4, lg: expanded ? 12 : 4 }}
      rowGap={3}
      py={expanded ? 4 : 1}
      flexWrap="wrap"
      alignItems="stretch"
    >
      {aggregations?.map(({ data, otherProps }) => {
        if (!otherProps) return null
        const { Icon, label, formatData } = otherProps
        let value = data && formatData(data)
        let text = (typeof value === 'number' ? round(value, 1) : '--').toLocaleString()
        if (label.toLowerCase().includes('duration') && typeof value === 'number')
          text = getDisplayDurationFromSeconds(value)
        const _label = value === 1 ? pluralize.singular(label) : label

        if (value === 0) {
          if (excludeLabels?.includes(label)) return null
        }

        return (
          <Flex key={label} align="center" gap={2}>
            {Icon && (
              <Circle
                hideBelow="lg"
                size="40px"
                bg="white"
                boxShadow="0px 4px 10px 0px rgba(0, 0, 0, 0.06)"
              >
                <Icon color="primary.500" fontSize="20px" />
              </Circle>
            )}
            <Flex direction="column">
              <Text textStyle="h6" opacity={value == null ? 0.5 : 1}>
                {text}
              </Text>
              <Text textStyle="bodyXSmall" opacity={0.6}>
                {_label}
              </Text>
            </Flex>
          </Flex>
        )
      })}
    </Flex>
  )
}
